const Template = () =>
  import(
    /* webpackChunkName: "messages-internal-template" */ '@/pages/message/internal/template/index.vue'
  )
const CreateTemplate = () =>
  import(
    /* webpackChunkName: "messages-internal-template" */ '@/pages/message/internal/template/create.vue'
  )
const EditTemplate = () =>
  import(
    /* webpackChunkName: "messages-internal-template" */ '@/pages/message/internal/template/edit.vue'
  )

export default {
  path: 'template',
  meta: {
    label: 'internalTemplate',
    auth: 'template'
  },
  component: {
    name: 'InternalTemplate',
    render(c) {
      return c('router-view')
    }
  },
  children: [
    {
      name: 'MessageInternalTemplate',
      path: '',
      meta: {
        label: 'report',
        auth: 'report'
      },
      component: Template
    },
    {
      name: 'MessageCreateInternalTemplate',
      path: 'create',
      meta: {
        label: 'create',
        auth: 'create'
      },
      component: CreateTemplate
    },
    {
      name: 'MessageEditInternalTemplate',
      path: 'edit/:id',
      meta: {
        label: 'edit',
        auth: 'update'
      },
      component: EditTemplate,
      props: true
    }
  ]
}
